import React from 'react';
import {
  Page,
  PageContent,
  Navbar,
  NavRight,
  Link,
  Block,
  Card,
  CardHeader,
  Popup,
  Sheet,
} from 'framework7-react';

function SheetPopup(props){
    if(props.type == "sheet"){
        return (
            <Sheet
                className={props.className}
                style={{height: 'auto', '--f7-sheet-bg-color': 'transparent', marginTop: '-20px'}}
                swipeToClose
                backdrop>
                <PageContent style={{borderTopRightRadius: '20px', borderTopLeftRadius: '20px', backgroundColor: '#fff'}}>
                    {props.children}
                </PageContent>
            </Sheet>
        )
    }
    else if(props.type == "popup"){
        return (
            <Popup 
                swipeToClose="to-bottom" 
                className={props.className}>
                <Page>
                <Navbar title={props.title}>
                    <NavRight>
                    <Link popupClose>Close</Link>
                    </NavRight>
                </Navbar>

                <Block className="pattern-banner bg-color-jasmine">
                    <Card style={{ width: '100%', margin: 0 }}>
                    <CardHeader>
                        <h3 style={{ margin: 0 }}>{props.title}</h3>
                    </CardHeader>
                    </Card>
                </Block>

                {/* Content for funding wallet */}
                {props.children}
                </Page>
            </Popup>
        )
    }
}

export default SheetPopup